import axios from 'axios'
import { clearSession, getToken } from '../utils/authSession'
import { rememberAuthFailure } from '../utils/authDiagnostics'

const apiBaseUrl = process.env.VUE_APP_API_BASE_URL || '/api'

export const http = axios.create({
  baseURL: apiBaseUrl,
  timeout: 15000
})

http.interceptors.request.use((config) => {
  const token = getToken()
  const isLoginRequest = config.url === '/v1/users/loginByPassword'
    || config.url === '/v1/users/register'

  if (token && !isLoginRequest) {
    config.headers.Authorization = `Bearer ${token}`
  }

  // Revalidate redirects cached before the local proxy target was corrected.
  if (process.env.NODE_ENV === 'development' && config.method === 'get') {
    config.headers['Cache-Control'] = 'no-cache'
    config.headers.Pragma = 'no-cache'
  }

  return config
})

http.interceptors.response.use(
  (response) => response,
  (error) => {
    const isLoginRequest = error.config?.url === '/v1/users/loginByPassword'
      || error.config?.url === '/v1/users/register'

    if (error.response?.status === 401 && !isLoginRequest) {
      rememberAuthFailure(error)
      clearSession()

      if (window.location.pathname !== '/login') {
        const redirect = `${window.location.pathname}${window.location.search}`
        window.location.replace(`/login?redirect=${encodeURIComponent(redirect)}`)
      }
    }

    return Promise.reject(error)
  }
)

export function unwrapApiResponse(response) {
  const result = response.data

  if (result?.code !== 2000) {
    throw new Error(result?.msg || '请求失败')
  }

  return result.data
}

export function getRequestErrorMessage(error, fallbackMessage) {
  if (error.code === 'ECONNABORTED' || error.code === 'ETIMEDOUT') {
    return '连接超时，请稍后重试'
  }
  if (error.response?.status >= 500) {
    return '服务暂时不可用，请稍后重试'
  }
  const responseData = error.response?.data

  if (responseData && typeof responseData === 'object') {
    return responseData.msg || responseData.message || fallbackMessage
  }

  if (typeof responseData === 'string' && responseData.trim() && !responseData.includes('<')) {
    return responseData
  }

  return error.code === 'ERR_NETWORK' ? '网络连接失败，请检查网络后重试' : error.message || fallbackMessage
}
